const state = {
  data:[],
}

const mutations = {
  COMMIT_DATA (state, data) {
    state.data = data
  },
}

const actions = {
  someAsyncTask ({ commit }, data) {
    // do something async
    commit('COMMIT_DATA', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
